import {
  normalizeAppReturnPath,
  POST_LOGIN_REDIRECT_STORAGE_KEY,
} from '@/lib/auth/post-login-redirect';
import { ROUTES } from '@/lib/constants/routes';
import { logger } from '@/lib/logger';
import { useAuthStore } from '@/store/auth.store';

/**
 * Clears client auth and redirects to the login route when an authenticated API call returns 401.
 * Kept separate from {@link apiRequest} so the fetch layer stays a thin transport.
 */
export function executeSessionExpiredRedirect(): void {
  logger.warn('Unauthorized access - logging out');
  const returnPath = `${window.location.pathname}${window.location.search}`;
  if (returnPath !== ROUTES.LOGIN) {
    sessionStorage.setItem(POST_LOGIN_REDIRECT_STORAGE_KEY, normalizeAppReturnPath(returnPath));
  }
  useAuthStore.getState().logout();
  window.location.href = ROUTES.LOGIN;
}
